<mat-dialog-content>
  <h2 mat-dialog-title>Send Verification to Customer</h2>
  <form>
    <mat-form-field appearance="fill" style="width:100%;margin-bottom:16px;">
      <mat-label>Hubspot Email</mat-label>
      <input matInput [value]="data.hs_email" disabled>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width:100%;margin-bottom:16px;">
      <mat-label>Internal Email</mat-label>
      <input matInput [value]="data.admin_email" disabled>
    </mat-form-field>
    @if (data.hs_email !== data.admin_email) {
      <mat-card color="warn" style="margin-bottom:16px; background:#fffbe7;">
        <mat-icon color="warn">warning</mat-icon>
        <span style="color:#ffbe00; font-weight:500;">
          Email mismatch: Emails will be sent to {{data.admin_email}}
        </span>
      </mat-card>
    }
    <mat-form-field appearance="fill" style="width:100%;margin-bottom:16px;">
      <mat-label>Quote ID</mat-label>
      <input matInput [value]="data.quoteTarget" disabled>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="send()">Send</button>
</mat-dialog-actions>
